import cx from 'classnames';

import Facebook from 'components/Icons/Facebook.svg';
import Instagram from 'components/Icons/Instagram.svg';
import Pinterest from 'components/Icons/Pinterest.svg';
import Twitter from 'components/Icons/Twitter.svg';
import Url from 'components/Icons/Url.svg';
import Yelp from 'components/Icons/Yelp.svg';

import { TProfessional } from 'types/appointment';

import s from './SocialMediaIcons.module.css';

type TProfessionalKeys = keyof TProfessional;

export interface SocialMediaIconsProps {
  className?: string;
  professional: TProfessional;
}

const icons = [
  <Facebook key="facebook" />,
  <Twitter className={s.icon} key="twitter" />,
  <Instagram className={s.icon} key="instagram" />,
  <Pinterest className={s.icon} key="pinterest" />,
  <Yelp className={s.icon} key="yelp" />,
  <Url className={s.icon} key="url" />,
];

const SocialMediaIcons = ({
  className,
  professional,
}: SocialMediaIconsProps) => {
  const links: {
    name: TProfessionalKeys;
    prefix: string;
    suffix: string;
  }[] = [
    {
      name: 'facebook_url',
      prefix: 'https://www.facebook.com/',
      suffix: 'on Facebook',
    },
    {
      name: 'twitter_url',
      prefix: 'https://twitter.com/',
      suffix: 'on Twitter',
    },
    {
      name: 'instagram_url',
      prefix: 'https://www.instagram.com/',
      suffix: 'on Instagram',
    },
    {
      name: 'pinterest_url',
      prefix: 'https://www.pinterest.com/',
      suffix: 'on Pinterest',
    },
    { name: 'yelp_url', prefix: 'https://www.yelp.com/', suffix: 'on Yelp' },
    { name: 'website_url', prefix: '', suffix: 'Official Site' },
  ];

  const showlinks = links.some((link) => professional[link.name]);

  return showlinks ? (
    <ul className={cx(s.socialMediaLinks, className)}>
      {links.map((link, index) => {
        const url = professional[link.name] as string;

        return (
          professional[link.name] && (
            <li key={index}>
              <a
                className={s.iconLink}
                href={url?.startsWith('http') ? url : link.prefix + url}
                target="_blank"
                rel="noreferrer"
                title={`${professional.full_name} ${link.suffix}`}
              >
                {icons[index]}
              </a>
            </li>
          )
        );
      })}
    </ul>
  ) : null;
};

export { SocialMediaIcons };
